<template>
  <div>
    <BOverlay
      :show="loading"
      no-center
      :opacity="0.3"
      variant="light"
      rounded="sm"
    >
      <template #overlay>
        <loading-spinner />
      </template>

      <paywall-boost-modal
        :profile-image="userProfileImage"
        :user-name="username"
        :modal-model="modalBoostFlow"
        :show-modal-data="modalBoostFlowData"
        :mobile="mobile"
        @update:modalModel="modalBoostFlow = $event"
      />

      <paywall-modal2
        :modal-model="modalFlow2"
        :modal-data="modalFlow2Data"
        :mobile="mobile"
        @update:modalModel="modalFlow2 = $event"
      />

      <BRow>
        <BCol cols="12">
          <div
            v-if="!mobile"
            class="cp-header"
          >
            <span class="cp-header-icon">
              <feather-icon
                icon="GiftIcon"
                size="22"
              />
            </span>
            <span class="cp-header-bar" />
            <div>
              <h3 class="campaigns-title">
                {{ $t('Campaigns') }}
              </h3>
              <p class="cp-header-sub">
                {{ $t('Special offers picked for you') }}
              </p>
            </div>
          </div>
          <BCard body-class="campaigns-body-class">
            <div v-if="false && Array.isArray(bannerPremium) && bannerPremium.length > 0" class="row mb-1 mt-1">
              <div class="col-sm-12 d-flex">
                <div class="p-relative campaign-enable-premium-container">
                  <div class="campaign-enable-premium-counter">
                    {{ convertTimeString(bannerPremium[0].remainingCounter || bannerPremium[0].paywallCounter) }}
                  </div>
                  <div class="campaign-enable-premium">
                    <p class="title">
                      {{ bannerPremium[0].bannerHeader }}
                    </p>
                    <p class="title">
                      {{ bannerPremium[0].bannerText }}
                    </p>
                    <div style="position: relative; margin-left: -10px">
                      <div style="position:absolute; left: -24px; top: 2px; z-index: 3; transform: rotate(2deg)">
                        <img
                          src="@/assets/images/paywall/diamond-1.svg"
                          alt="diamond"
                          width="22"
                        >
                      </div>
                      <div style="position:absolute; left: -74px; top: 18px; z-index: 3; transform: rotate(39deg)">
                        <img
                          src="@/assets/images/paywall/diamond-1.svg"
                          alt="diamond"
                          width="22"
                        >
                      </div>
                      <div style="position:absolute; right: -24px; top: 2px; z-index: 3; transform: rotate(2deg)">
                        <img
                          src="@/assets/images/paywall/diamond-1.svg"
                          alt="diamond"
                          width="22"
                        >
                      </div>
                      <div style="position:absolute; right: -36px; top: 32px; z-index: 3; transform: rotate(32deg)">
                        <img
                          src="@/assets/images/paywall/diamond-1.svg"
                          alt="diamond"
                          width="14"
                        >
                      </div>
                      <div style="position:absolute; right: -60px; top: 10px; z-index: 3; transform: rotate(50deg)">
                        <img
                          src="@/assets/images/paywall/diamond-1.svg"
                          alt="diamond"
                          width="12"
                        >
                      </div>
                      <div style="position:absolute; left: -36px; top: 32px; z-index: 3; transform: rotate(32deg)">
                        <img
                          src="@/assets/images/paywall/diamond-1.svg"
                          alt="diamond"
                          width="14"
                        >
                      </div>
                      <div style="position:absolute; left: -52px; top: 56px; z-index: 3; transform: rotate(18deg)">
                        <img
                          src="@/assets/images/paywall/diamond-1.svg"
                          alt="diamond"
                          width="12"
                        >
                      </div>
                      <div style="position:absolute; right: -28px; bottom: 2px; z-index: 3; transform: rotate(74deg)">
                        <img
                          src="@/assets/images/paywall/diamond-1.svg"
                          alt="diamond"
                          width="22"
                        >
                      </div>
                      <div style="position:absolute; right: -68px; bottom: 14px; z-index: 3; transform: rotate(14deg)">
                        <img
                          src="@/assets/images/paywall/diamond-1.svg"
                          alt="diamond"
                          width="22"
                        >
                      </div>
                      <div style="position:absolute; left: -28px; bottom: 2px; z-index: 3; transform: rotate(74deg)">
                        <img
                          src="@/assets/images/paywall/diamond-1.svg"
                          alt="diamond"
                          width="22"
                        >
                      </div>
                      <div style="position:absolute; right: -23px; bottom: -10px; z-index: 0;">
                        <img
                          src="@/assets/images/paywall/profile-bg.png"
                          alt="bg"
                          width="116"
                        >
                      </div>
                      <b-avatar
                        v-if="userProfileImage"
                        size="80"
                        :src="userProfileImage"
                        class="mt-1"
                      />
                    </div>
                    <div>
                      <p>
                        {{ $t('Diamonds left to reach premium status') }}
                      </p>
                    </div>
                    <div class="reward-progress">
                      <b-progress
                        variant="success"
                        :max="5000"
                        height="2rem"
                      >
                        <b-progress-bar :value="userCredits">
                          <div class="reward-progress-bar">
                            {{ userCredits }} / {{ 5000 }}
                          </div>
                        </b-progress-bar>
                      </b-progress>
                    </div>
                    <div
                      class="campaign-enable-premium-button btn-primary2"
                      style="min-width: 120px"
                      @click="goMarket"
                    >
                      {{ bannerPremium[0].bannerButtonText }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="hasCampaign">
              <div
                v-if="Array.isArray(bannerWithUser1) && bannerWithUser1.length > 0"
                class="row mb-1 mt-1"
              >
                <div class="col-sm-12 d-flex">
                  <div
                    v-for="(banner, i) in bannerWithUser1"
                    :key="i"
                    class="p-relative new-paywall1-container"
                  >
                    <div
                      v-if="banner.remainingCounter || banner.paywallCounter"
                      class="new-paywall1-counter"
                    >
                      {{ convertTimeString(banner.remainingCounter || banner.paywallCounter) }}
                      <div style="position:absolute; right: -10px; top: -4px;">
                        <img
                          src="@/assets/images/paywall/half-star-1.svg"
                          alt="half star"
                          width="24"
                        >
                      </div>
                    </div>
                    <div class="new-paywall1">
                      <div style="position:absolute; left: -11px; top: -11px;">
                        <img
                          src="@/assets/images/paywall/half-star-1.svg"
                          alt="half star"
                          width="36"
                        >
                      </div>
                      <div style="position:absolute; right: 10px; bottom: 10px;">
                        <img
                          src="@/assets/images/paywall/half-star-1.svg"
                          alt="half star"
                          width="20"
                        >
                      </div>
                      <div style="position:absolute; right: 0; top: -4px;">
                        <img
                          src="@/assets/images/paywall/half-stars-1.svg"
                          alt="half stars"
                          width="48"
                        >
                      </div>
                      <div style="position: relative">
                        <div style="position:absolute; left: -1px; bottom: 12px; z-index: 3; transform: rotate(75deg)">
                          <img
                            src="@/assets/images/paywall/diamond-1.svg"
                            alt="diamond"
                            width="12"
                          >
                        </div>
                        <div style="position:absolute; right: -1px; top: 12px; z-index: 3; transform: rotate(75deg)">
                          <img
                            src="@/assets/images/paywall/diamond-1.svg"
                            alt="diamond"
                            width="12"
                          >
                        </div>
                        <div style="position:absolute; left: -6px; top: 16px; z-index: 3">
                          <img
                            src="@/assets/images/paywall/diamond-1.svg"
                            alt="diamond"
                            width="20"
                          >
                        </div>
                        <div style="position:absolute; right: -6px; bottom: 20px; z-index: 3; transform: rotate(60deg)">
                          <img
                            src="@/assets/images/paywall/diamond-1.svg"
                            alt="diamond"
                            width="16"
                          >
                        </div>
                        <b-avatar
                          v-if="banner.bannerProfileImage"
                          size="88"
                          :src="banner.bannerProfileImage"
                        />
                      </div>
                      <div class="d-flex flex-column align-items-center justify-content-between h-100">
                        <div>
                          <p style="color: #FFE61A">
                            {{ banner.bannerHeader }}
                          </p>
                          <p>
                            {{ banner.bannerText }}
                          </p>
                        </div>
                        <div
                          v-if="banner.webProduct && banner.bannerAction === 'product'"
                          @click="buyProduct({banner, name: 'buy', params: {productId: banner.webProduct, purchaseSource: 'banner-with-user-1', }, query: {campaignId: banner.campaignId, campaignType: banner.campaignType}})">
                          <div
                            class="new-paywall1-button"
                            style="min-width: 120px"
                          >
                            {{ banner.bannerButtonText }}
                          </div>
                        </div>
                        <div
                          v-else-if="banner.bannerAction === 'popup'"
                          class="new-paywall1-button cursor-pointer"
                          style="min-width: 120px"
                          @click="openPopup(banner)"
                        >
                          {{ banner.bannerButtonText }}
                        </div>
                        <div
                          v-else
                          class="new-paywall1-button"
                          style="min-width: 120px"
                          @click="goMarket"
                        >
                          {{ banner.bannerButtonText }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="Array.isArray(bannerPremium) && bannerPremium.length > 0"
                class="row mb-1"
              >
                <div class="col-sm-12 d-flex">
                  <div
                    v-for="(banner, i) in bannerPremium"
                    :key="i"
                    class="p-relative new-paywall2-container"
                  >
                    <div class="new-paywall2">
                      <div style="position:absolute; left: -6px; top: -5px; transform: rotate(32deg)">
                        <img
                          src="@/assets/images/paywall/diamond-1.svg"
                          alt="half star"
                          width="20"
                        >
                      </div>
                      <div style="position:absolute; right: 10px; bottom: 10px;">
                        <img
                          src="@/assets/images/paywall/half-star-1.svg"
                          alt="half star"
                          width="20"
                        >
                      </div>
                      <div style="position:absolute; right: 0; top: -4px;">
                        <img
                          src="@/assets/images/paywall/half-stars-1.svg"
                          alt="half stars"
                          width="48"
                        >
                      </div>
                      <div style="position: relative; margin-left: -10px">
                        <div style="position:absolute; right: -24px; top: 2px; z-index: 3; transform: rotate(2deg)">
                          <img
                            src="@/assets/images/paywall/diamond-1.svg"
                            alt="diamond"
                            width="22"
                          >
                        </div>
                        <div style="position:absolute; right: -36px; top: 32px; z-index: 3; transform: rotate(32deg)">
                          <img
                            src="@/assets/images/paywall/diamond-1.svg"
                            alt="diamond"
                            width="14"
                          >
                        </div>
                        <div style="position:absolute; right: -28px; bottom: 2px; z-index: 3; transform: rotate(74deg)">
                          <img
                            src="@/assets/images/paywall/diamond-1.svg"
                            alt="diamond"
                            width="22"
                          >
                        </div>
                        <div style="position:absolute; right: -23px; bottom: -10px; z-index: 0;">
                          <img
                            src="@/assets/images/paywall/profile-bg.png"
                            alt="bg"
                            width="116"
                          >
                        </div>
                        <b-avatar
                          v-if="userProfileImage"
                          size="80"
                          :src="userProfileImage"
                          class="mt-1"
                        />
                      </div>
                      <div class="d-flex flex-column align-items-center justify-content-between w-100 h-100 pr-2">
                        <div class="d-flex flex-column align-items-center justify-content-between">
                          <p>
                            {{ banner.bannerHeader }}
                          </p>
                          <p>
                            {{ banner.bannerText }}
                          </p>
                        </div>
                        <div
                          v-if="banner.webProduct && banner.bannerAction === 'product'"
                          @click="buyProduct({banner, name: 'buy', params: {productId: banner.webProduct, purchaseSource: 'banner-premium'}, query: {campaignId: banner.campaignId, campaignType: banner.campaignType}})"
                        >
                          <div
                            class="new-paywall2-button"
                            style="min-width: 120px"
                          >
                            {{ banner.bannerButtonText }}
                          </div>
                        </div>
                        <div
                          v-else-if="banner.bannerAction === 'popup'"
                          class="new-paywall2-button cursor-pointer"
                          style="min-width: 120px"
                          @click="openPopup(banner)"
                        >
                          {{ banner.bannerButtonText }}
                        </div>
                        <div
                          v-else
                          class="new-paywall2-button"
                          style="min-width: 120px"
                          @click="goMarket"
                        >
                          {{ banner.bannerButtonText }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="Array.isArray(banner1) && banner1.length > 0"
                class="row mb-1"
              >
                <div class="col-sm-12 d-flex">
                  <div
                    v-for="(banner, i) in banner1"
                    :key="i"
                    class="p-relative new-paywall3-container"
                  >
                    <div
                      v-if="banner.remainingCounter || banner.paywallCounter"
                      class="new-paywall3-counter"
                    >
                      {{ convertTimeString(banner.remainingCounter || banner.paywallCounter) }}
                    </div>
                    <div class="new-paywall3">
                      <div style="position:absolute; right: 4px; bottom: 32px;">
                        <img
                          src="@/assets/images/paywall/half-star-1.svg"
                          alt="half star"
                          width="18"
                        >
                      </div>
                      <div style="position:absolute; right: 0; top: -4px;">
                        <img
                          src="@/assets/images/paywall/half-stars-1.svg"
                          alt="half stars"
                          width="48"
                        >
                      </div>
                      <div style="position:absolute; left: -6px; bottom: -10px; z-index: 1;">
                        <img
                          src="@/assets/images/paywall/paywall3-left.png"
                          width="136"
                        />
                      </div>
                      <div
                        class="d-flex flex-column align-items-center justify-content-center h-100 gap-6"
                        style="margin-left: 90px; width: calc(100% - 130px)"
                      >
                        <div>
                          <p class="text-center">
                            {{ banner.bannerHeader }}
                          </p>
                          <p class="text-center">
                            {{ banner.bannerText }}
                          </p>
                        </div>
                        <div
                          v-if="banner.webProduct && banner.bannerAction === 'product'"
                          @click="buyProduct({banner, name: 'buy', params: {productId: banner.webProduct, purchaseSource: 'banner-1'}, query: {campaignId: banner.campaignId, campaignType: banner.campaignType}})"
                        >
                          <div
                            class="new-paywall3-button"
                            style="min-width: 120px"
                          >
                            {{ banner.bannerButtonText }}
                          </div>
                        </div>
                        <div
                          v-else
                          class="new-paywall3-button"
                          style="min-width: 120px"
                          @click="goMarket"
                        >
                          {{ banner.bannerButtonText }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="Array.isArray(bannerChat) && bannerChat.length > 0"
                class="row mb-1"
              >
                <div class="col-sm-12 d-flex">
                  <div
                    v-for="(banner, i) in bannerChat"
                    :key="i"
                    class="p-relative new-paywall4-container"
                  >
                    <div
                      v-if="banner.remainingCounter || banner.paywallCounter"
                      class="new-paywall4-counter"
                    >
                      {{ convertTimeString(banner.remainingCounter || banner.paywallCounter) }}
                    </div>
                    <div class="new-paywall4">
                      <div style="position:absolute; right: 10px; bottom: 10px;">
                        <img
                          src="@/assets/images/paywall/half-star-1.svg"
                          alt="half star"
                          width="20"
                        >
                      </div>
                      <div style="position:absolute; right: 0; top: -4px;">
                        <img
                          src="@/assets/images/paywall/half-stars-1.svg"
                          alt="half stars"
                          width="48"
                        >
                      </div>
                      <div style="position: relative; margin-left: -26px; margin-top: -24px">
                        <div style="position:absolute; left: 8px; bottom: 2px; z-index: 3;">
                          <img
                            src="@/assets/images/paywall/half-star-1.svg"
                            alt="diamond"
                            width="22"
                          >
                        </div>
                        <div style="position:absolute; right: 8px; top: 4px; z-index: 3;">
                          <img
                            src="@/assets/images/paywall/half-star-1.svg"
                            alt="diamond"
                            width="16"
                          >
                        </div>
                        <div style="position:absolute; right: -6px; bottom: 10px; z-index: 3;">
                          <img
                            src="@/assets/images/paywall/half-star-1.svg"
                            alt="diamond"
                            width="12"
                          >
                        </div>
                        <img
                          src="@/assets/images/paywall/message-icon.png"
                          width="110"
                        />
                      </div>
                      <div
                        class="d-flex flex-column align-items-center justify-content-center h-100"
                        style="gap: 6px;"
                      >
                        <div>
                          <p>
                            {{ banner.bannerHeader }}
                          </p>
                        </div>
                        <div
                          class="d-flex flex-column justify-content-center align-items-center"
                          @click="goChat"
                        >
                          <div class="new-paywall4-button-top">
                            {{ banner.bannerText }}
                          </div>
                          <div
                            class="new-paywall4-button"
                            style="min-width: 120px"
                          >
                            {{ banner.bannerButtonText }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else-if="!loading && !hasCampaign"
              class="cp-empty"
            >
              <span class="cp-empty-icon">
                <feather-icon
                  icon="GiftIcon"
                  size="32"
                />
              </span>
              <h3>{{ $t('No matching campaigns found') }}</h3>
            </div>
          </BCard>
        </BCol>
      </BRow>
    </BOverlay>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { throwDefaultError } from '@/helpers/helpers'
import {
  BAvatar, BCard, BCol, BOverlay, BProgress, BProgressBar, BRow,
} from 'bootstrap-vue'
import PaywallModal2 from '@/components/PaywallModal2.vue'
import PaywallBoostModal from '@/components/PaywallBoostModal.vue'

export default {
  name: 'CampaignsComponent',
  components: {
    BProgress,
    BProgressBar,
    PaywallModal2,
    PaywallBoostModal,
    BAvatar,
    BCard,
    BCol,
    BOverlay,
    BRow,
  },
  props: {
    mobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      bannerChat: null,
      bannerWithUser1: null,
      bannerPremium: null,
      banner1: null,
      bannerSlide: 0,
      callSource: 'campaigns',
      loading: false,
      modalFlow2: false,
      modalFlow2Data: null,
      modalBoostFlow: false,
      modalBoostFlowData: null,
      premiumCreditsCount: 5000,
      premiumTimeInterval: null,
      premiumTimeSeconds: 60 * 60 * 24,
      users: [],
    }
  },
  watch: {
    $route: {
      // eslint-disable-next-line no-unused-vars
      handler(value) {
        this.modalAddMainScreen = false
        this.modalCongrats = false
        this.modalMessageCompleted = true
        this.modalFlow2 = false
        this.modalFlow2Data = null
        this.modalBoostFlow = false
        this.modalBoostFlowData = null
      },
      deep: true,
    },
  },
  computed: {
    hasCampaign() {
      return (Array.isArray(this.bannerWithUser1) && this.bannerWithUser1.length > 0)
          || (Array.isArray(this.bannerPremium) && this.bannerPremium.length > 0)
          || (Array.isArray(this.banner1) && this.banner1.length > 0)
          || (Array.isArray(this.bannerChat) && this.bannerChat.length > 0)
    },
    userCanStartVideoCall() {
      return this.$store.getters['auth/userCanStartVideoCall']
    },
    userCredits() {
      return this.$store.getters['auth/userCredits']
    },
    username() {
      return this.$store.getters['auth/userName']
    },
    userProfileImage() {
      return this.$store.getters['auth/profileImage']
    },
  },
  created() {
    this.getCampaigns2()

    this.startPremiumTimeInterval()
  },
  methods: {
    buyProduct(product) {
      if (this.mobile) {
        if (window.webkit) {
          if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
            // eslint-disable-next-line radix
            window.webkit.messageHandlers.iosListener.postMessage({
              key: 'buy-button',
              params: {
                id: product.banner.iosProduct,
              },
            })
          }
        }
        if (window.AndroidApp) {
          // eslint-disable-next-line radix
          window.AndroidApp.sendData(JSON.stringify({
            key: 'buy-button',
            params: {
              id: product.banner.androidProduct,
            },
          }))
        }
      } else {
        this.$router.push({
          name: product.name,
          params: product.params,
          query: product.query,
        })
      }
    },
    goMarket() {
      if (this.mobile) {
        if (window.webkit) {
          if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
            // eslint-disable-next-line radix
            window.webkit.messageHandlers.iosListener.postMessage({
              key: 'go-market',
            })
          }
        }
        if (window.AndroidApp) {
          // eslint-disable-next-line radix
          window.AndroidApp.sendData(JSON.stringify({
            key: 'go-market',
          }))
        }
      } else {
        this.$router.push({
          name: 'market',
        })
      }
    },
    goChat() {
      if (this.mobile) {
        if (window.webkit) {
          if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
            // eslint-disable-next-line radix
            window.webkit.messageHandlers.iosListener.postMessage({
              key: 'go-chat',
            })
          }
        }
        if (window.AndroidApp) {
          // eslint-disable-next-line radix
          window.AndroidApp.sendData(JSON.stringify({
            key: 'go-chat',
          }))
        }
      } else {
        this.$router.push({
          name: 'chat',
        })
      }
    },
    convertTimeString(counter) {
      // Koşul 2: Sayaç 0 veya daha az ise, doğrudan "00:00:00" döndür.
      if (counter <= 0) {
        return '00:00:00'
      }

      // Orijinal hesaplama mantığınızı koruyoruz.
      const remainingDays = Math.floor(counter / (3600 * 24))
      const secondsInLastDay = counter % (3600 * 24)

      const remainingHours = Math.floor(secondsInLastDay / 3600) + (remainingDays * 24)
      const remainingMinutes = Math.floor((secondsInLastDay % 3600) / 60)
      const remainingSeconds = secondsInLastDay % 60

      // Koşul 1: Her bir değeri string'e çevirip, 2 karakter uzunluğunda olana kadar
      // başına '0' ekliyoruz (padStart).
      const formattedHours = String(remainingHours).padStart(2, '0')
      const formattedMinutes = String(remainingMinutes).padStart(2, '0')
      const formattedSeconds = String(remainingSeconds).padStart(2, '0')

      return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    },
    getCampaigns2() {
      this.loading = true

      useJwt.campaigns2()
        .then(response => {
          if (response.data.body) {
            this.$store.dispatch('app/setCampaigns', response.data.body)

            this.setCampaignBanners(response.data.body)
          }
        })
        .catch(error => {
          throwDefaultError(this.$toast, error)
        })
        .then(() => {
          this.loading = false
        })
    },
    openPopup(campaign) {
      if (!campaign) return

      if (campaign.bannerAction === 'popup') {
        if (campaign.popupLayout === 'popup-with-user-1') {
          this.modalFlow2 = true
          this.modalFlow2Data = {
            ...campaign,
          }
        } else if (campaign.popupLayout === 'popup-premium') {
          this.modalBoostFlow = true
          this.modalBoostFlowData = {
            ...campaign,
          }
        }
      }
    },
    setCampaignBanners(campaigns) {
      if (Array.isArray(campaigns)) {
        try {
          this.bannerWithUser1 = campaigns.filter(campaign => {
            return campaign.bannerLayout === 'banner-with-user-1'
                && Array.isArray(campaign.displayAreas) && campaign.displayAreas.includes('banner')
          })

          if (this.bannerWithUser1 && this.bannerWithUser1.length > 0) {
            this.bannerWithUser1.forEach(banner => {
              // Displayed isteği gönder
              if (banner.campaignId) {
                useJwt.campaignsDisplayed({ campaignId: banner.campaignId })
              }

              // Her bir banner'ın sayacını kontrol edip, varsa ve 0'dan büyükse değerini bir azaltıyoruz.
              if ((typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) || (typeof banner.paywallCounter === 'number' && banner.paywallCounter > 0)) {
                if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                  banner.remainingCounter *= 60
                }
                banner.paywallCounter *= 60
                setInterval(() => {
                  if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                    banner.remainingCounter -= 1
                  }
                  banner.paywallCounter -= 1
                }, 1000)
              }
            })
          }
        } catch (e) {
          // console.log(e);
        }

        try {
          this.bannerChat = campaigns.filter(campaign => {
            return campaign.bannerLayout === 'banner-chat'
                && Array.isArray(campaign.displayAreas) && campaign.displayAreas.includes('banner')
          })

          if (this.bannerChat && this.bannerChat.length > 0) {
            this.bannerChat.forEach(banner => {
              if (banner.campaignId) {
                useJwt.campaignsDisplayed({ campaignId: banner.campaignId })
              }

              // Her bir elemanın sayacını kontrol edip, varsa ve 0'dan büyükse değerini azaltıyoruz.
              if ((typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) || (typeof banner.paywallCounter === 'number' && banner.paywallCounter > 0)) {
                if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                  banner.remainingCounter *= 60
                }
                banner.paywallCounter *= 60
                setInterval(() => {
                  if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                    banner.remainingCounter -= 1
                  }
                  banner.paywallCounter -= 1
                }, 1000)
              }
            })
          }
        } catch (e) {
          // console.log(e);
        }

        try {
          this.banner1 = campaigns.filter(campaign => {
            return campaign.bannerLayout === 'banner-1'
                && Array.isArray(campaign.displayAreas) && campaign.displayAreas.includes('banner')
          })

          // Eğer en az bir banner bulunduysa (array'in uzunluğu 0'dan büyükse) devam et.
          if (this.banner1 && this.banner1.length > 0) {
            this.banner1.forEach(banner => {
              if (banner.campaignId) {
                useJwt.campaignsDisplayed({ campaignId: banner.campaignId })
              }

              // Her bir banner objesinin remainingCounter'ı var mı ve sayı mı diye kontrol edilir.
              if ((typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) || (typeof banner.paywallCounter === 'number' && banner.paywallCounter > 0)) {
                if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                  banner.remainingCounter *= 60
                }
                banner.paywallCounter *= 60
                setInterval(() => {
                  if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                    banner.remainingCounter -= 1
                  }
                  banner.paywallCounter -= 1
                }, 1000)
              }
            })
          }
        } catch (e) {
          // console.log(e);
        }

        try {
          // Koşula uyan tüm 'banner-premium' kampanyaları bir dizi olarak atanır.
          this.bannerPremium = campaigns.filter(campaign => {
            return campaign.bannerLayout === 'banner-premium'
                && Array.isArray(campaign.displayAreas) && campaign.displayAreas.includes('banner')
          })

          if (this.bannerPremium && this.bannerPremium.length > 0) {
            // Bu sayede her bir banner için ayrı interval oluşturmanın önüne geçilir.
            this.bannerPremium.forEach(banner => {
              if (banner.campaignId) {
                useJwt.campaignsDisplayed({ campaignId: banner.campaignId })
              }

              // Her bir banner objesi için sayacın varlığını, türünü ve değerini kontrol ediyoruz.
              if ((typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) || (typeof banner.paywallCounter === 'number' && banner.paywallCounter > 0)) {
                if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                  banner.remainingCounter *= 60
                }
                banner.paywallCounter *= 60
                setInterval(() => {
                  if (typeof banner.remainingCounter === 'number' && banner.remainingCounter > 0) {
                    banner.remainingCounter -= 1
                  }
                  banner.paywallCounter -= 1
                }, 1000)
              }
            })
          }
        } catch (e) {
          // console.log(e);
        }
      }
    },
    startPremiumTimeInterval() {
      if (!this.premiumTimeInterval && this.premiumTimeSeconds) {
        this.premiumTimeInterval = setInterval(() => {
          if (this.premiumTimeSeconds >= 0) {
            this.premiumTimeSeconds -= 1
          }
        }, 1000)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.campaigns-title {
  color: #56009B;
  margin-bottom: 0;
  display: inline-block;
  font-weight: bold;
  font-size: 24px;
  font-family: 'Poppins', sans-serif;
}
.campaign-banner-container {
  width: 100%;
  display: flex;
  justify-content: center;
  .campaign-banner {
    display: flex;
    position: relative;
    padding: 10px;
    text-align: center;
    min-height: 110px;
    width: 420px;
    max-width: 105%;
    margin-left: -2.5%;
    border-radius: 10px;
    background: url('~@/assets/images/bg/add-main-screen-bg.jpg') center center no-repeat;
    background-size: contain;
    margin-bottom: 8px;
    flex-direction: column;
    align-items: center;

    .banner-counter {
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 3px;
      left: 0;
      top: 10px;
      padding: 2px 22px;
      border-radius: 12px;
      background: #9327FF;
      color: #fff;
      font-size: 10px;
    }

    p {
      font-family: 'Lexend Deca', sans-serif;
      color: #272727;
      margin-bottom: 2px;
    }
    p:first-of-type {
      font-size: 12px !important;
      font-weight: 500 !important;
    }
    p:last-of-type {
      font-size: 16px !important;
      font-weight: bold !important;
      margin-bottom: 8px;
    }

    button {
      font-size: 14px !important;
      padding: 4px 24px !important;
    }
  }
}

.new-paywall1-container {
  width: 440px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  background: linear-gradient(to bottom, #600032, #000000);
  border-radius: 12px;
  position: relative;
  margin-bottom: 8px;
  .new-paywall1-counter {
    font-family: 'Poppins', sans-serif !important;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    left: 0;
    bottom: 0;
    padding: 4px 24px 4px 12px;
    background: linear-gradient(to right, #FFDB6C, #EB944700);
    color: #000;
    font-size: 10px;
    font-weight: bold;
    z-index: 2;
    border-bottom-left-radius: 12px;
  }
  .new-paywall1 {
    display: flex;
    position: relative;
    padding: 6px 16px;
    text-align: center;
    min-height: 110px;
    width: 420px;
    max-width: 100%;
    border-radius: 10px;
    background-size: contain;
    flex-direction: row;
    align-items: center;
    gap: 12px;

    p {
      font-family: 'Poppins', sans-serif !important;
      color: #fff;
      margin-bottom: 2px;
      font-size: 12px !important;
      font-weight: 700 !important;
    }

    .new-paywall1-button {
      background-color: #fff;
      color: #5E0131;
      border-radius: 16px;
      font-size: 10px !important;
      font-weight: bold;
      padding: 8px 24px !important;
      cursor: pointer;
    }
  }
}

.new-paywall2-container {
  width: 440px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  background: linear-gradient(to bottom, #222222, #000000);
  border-radius: 12px;
  position: relative;
  margin-bottom: 8px;
  .new-paywall2 {
    display: flex;
    position: relative;
    padding: 6px 16px;
    text-align: center;
    min-height: 110px;
    width: 420px;
    max-width: 100%;
    border-radius: 10px;
    background-size: contain;
    flex-direction: row;
    align-items: center;
    gap: 12px;

    p {
      font-family: 'Poppins', sans-serif !important;
      color: #9935EF;
      margin-bottom: 2px;
      font-size: 15px !important;
      font-weight: 700 !important;
      text-align: center;
    }

    .new-paywall2-button {
      background-color: #fff;
      color: #B530EC;
      border-radius: 16px;
      font-size: 13px !important;
      font-weight: bold;
      padding: 8px 24px !important;
      cursor: pointer;
    }
  }
}

.new-paywall3-container {
  width: 440px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  background: linear-gradient(to bottom, #B430ED, #EF055E);
  border-radius: 12px;
  position: relative;
  margin-bottom: 8px;
  .new-paywall3-counter {
    font-family: 'Poppins', sans-serif !important;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    left: 0;
    bottom: 0;
    padding: 4px 24px 4px 12px;
    background: linear-gradient(to right, #FFFFFF, #FFFFFF00);
    color: #000;
    font-size: 10px;
    font-weight: bold;
    z-index: 2;
    border-bottom-left-radius: 12px;
  }
  .new-paywall3 {
    display: flex;
    position: relative;
    padding: 6px 16px;
    text-align: center;
    min-height: 110px;
    width: 420px;
    max-width: 100%;
    border-radius: 10px;
    background-size: contain;
    flex-direction: row;
    align-items: center;
    gap: 12px;

    p {
      font-family: 'Poppins', sans-serif !important;
      color: #fff;
      margin-bottom: 2px;
      font-size: 13px !important;
      font-weight: 700 !important;
    }

    .new-paywall3-button {
      background-color: #fff;
      color: #B530EC;
      border-radius: 16px;
      font-size: 14px !important;
      font-weight: bold;
      padding: 6px 24px !important;
      cursor: pointer;
    }
  }
}

.new-paywall4-container {
  width: 440px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  background: linear-gradient(to bottom, #730C98, #000000);
  border-radius: 12px;
  position: relative;
  margin-bottom: 8px;
  .new-paywall4-counter {
    font-family: 'Poppins', sans-serif !important;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    left: 0;
    bottom: 0;
    padding: 4px 24px 4px 12px;
    background: linear-gradient(to right, #FFDB6C, #EB944700);
    color: #000;
    font-size: 10px;
    font-weight: bold;
    z-index: 2;
    border-bottom-left-radius: 12px;
  }
  .new-paywall4 {
    display: flex;
    position: relative;
    padding: 6px 16px;
    text-align: center;
    min-height: 110px;
    width: 420px;
    max-width: 100%;
    border-radius: 10px;
    background-size: contain;
    flex-direction: row;
    align-items: center;
    gap: 12px;

    p {
      font-family: 'Poppins', sans-serif !important;
      color: #fff;
      margin-bottom: 2px;
      font-size: 12px !important;
      font-weight: 700 !important;
      margin-right: 12px;
    }

    .new-paywall4-button-top {
      background: linear-gradient(to bottom, #DB34F3, #7F1E8D);
      color: #fff;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      font-size: 11px !important;
      font-weight: bold;
      padding: 4px 12px !important;
      margin-bottom: 0 !important;
      width: 70px;
    }
    .new-paywall4-button {
      background-color: #fff;
      color: #730C97;
      border-radius: 16px;
      font-size: 11px !important;
      font-weight: bold;
      padding: 8px 20px !important;
      cursor: pointer;
    }
  }
}

.campaign-enable-premium-container {
  width: 440px;
  max-width: 100%;
  display: flex;
  justify-content: center;
  background: linear-gradient(to right, #000000, #212121);
  border-radius: 12px;
  position: relative;
  margin-bottom: 8px;
  .campaign-enable-premium-counter {
    font-family: 'Poppins', sans-serif !important;
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    left: 0;
    bottom: 0;
    padding: 4px 24px 4px 12px;
    background: linear-gradient(to right, #FFDB6C, #EB944700);
    color: #000;
    font-size: 10px;
    font-weight: bold;
    z-index: 2;
    border-bottom-left-radius: 12px;
  }
  .campaign-enable-premium {
    display: flex;
    position: relative;
    padding: 10px;
    text-align: center;
    width: 420px;
    max-width: 100%;
    border-radius: 10px;
    background-size: contain;
    flex-direction: column;
    align-items: center;
    gap: 12px;

    p {
      font-family: 'Poppins', sans-serif !important;
      color: #E7BF37;
      margin-bottom: 2px;
      font-size: 13px !important;
      font-weight: 700 !important;
      margin-right: 12px;

      &.title {
        color: #9935EF;
        font-size: 17px !important;
        margin-right: 0 !important;
      }
    }

    .campaign-enable-premium-button {
      padding: 8px 24px;
      font-weight: bold !important;
      min-width: 190px !important;
    }
  }
}

.reward-progress {
  position:relative;
  margin-bottom: 16px;
  width: 100%;
  border-radius: 16px;
  background-color: #2D2D2D;

  .progress-bar {
    &.bg-success {
      background-image: linear-gradient(to right, #FBF258, #DEA627);
    }
  }

  .reward-progress-bean {
    position:absolute;
    left: 0;
    top: -8px
  }

  .reward-progress-bar {
    position: absolute;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-weight: bold;
  }
}

.campaigns-body-class {
  padding: 12px 8px;
}

/* =========================================================
   Kampanyalar — yeni koyu UI (sadece görünüm)
   ========================================================= */
.cp-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 8px 0 22px;
  padding: 0 4px;

  .cp-header-icon {
    width: 46px;
    height: 46px;
    border-radius: 14px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: linear-gradient(135deg, #ff4fa8, #c026d3);
    box-shadow: 0 6px 18px rgba(234, 3, 178, 0.4);
  }

  .cp-header-bar {
    width: 4px;
    align-self: stretch;
    min-height: 46px;
    border-radius: 4px;
    background: linear-gradient(180deg, #ea03b2, #a855f7);
  }

  .campaigns-title {
    color: #fff !important;
    font-family: inherit;
    font-size: 26px;
    font-weight: 800;
  }

  .cp-header-sub {
    margin: 2px 0 0;
    color: rgba(226, 220, 255, 0.72);
    font-size: 13px;
  }
}

::v-deep .card {
  background: transparent !important;
  box-shadow: none !important;
  border: 0 !important;
}

::v-deep .campaigns-body-class {
  padding: 0 4px 24px !important;

  .col-sm-12.d-flex {
    flex-wrap: wrap;
    gap: 18px;
  }

  p { font-family: inherit !important; }
}

.new-paywall1-container,
.new-paywall2-container,
.new-paywall3-container,
.new-paywall4-container,
.campaign-enable-premium-container {
  --cp-accent: rgba(234, 3, 178, 0.55);
  --cp-glow: rgba(234, 3, 178, 0.25);

  width: 460px;
  max-width: 100%;
  margin-bottom: 4px;
  border-radius: 20px;
  overflow: hidden;
  border: 1.5px solid var(--cp-accent);
  box-shadow: 0 12px 30px rgba(4, 2, 20, 0.45), 0 0 20px var(--cp-glow);
  transition: transform .2s ease, box-shadow .2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 16px 36px rgba(4, 2, 20, 0.55), 0 0 28px var(--cp-glow);
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(ellipse 60% 70% at 20% 50%, var(--cp-glow), transparent 70%);
    pointer-events: none;
  }

  > *:not([class*="-counter"]) { position: relative; z-index: 1; }
  > [class*="-counter"] { z-index: 3; }
}

.new-paywall1-container {
  --cp-accent: rgba(255, 31, 143, 0.6);
  --cp-glow: rgba(255, 31, 143, 0.28);
  background: linear-gradient(135deg, #4a0a3a 0%, #24104f 60%, #170f3d 100%);
}

.new-paywall2-container {
  --cp-accent: rgba(168, 85, 247, 0.65);
  --cp-glow: rgba(168, 85, 247, 0.28);
  background: linear-gradient(135deg, #2b1a63 0%, #1d1247 60%, #120b30 100%);

  .new-paywall2 p { color: #e9d5ff !important; }
}

.new-paywall3-container {
  --cp-accent: rgba(255, 255, 255, 0.35);
  --cp-glow: rgba(239, 5, 94, 0.3);
  background: linear-gradient(135deg, #a21caf 0%, #db2777 55%, #7c3aed 100%);
}

.new-paywall4-container {
  --cp-accent: rgba(192, 38, 211, 0.6);
  --cp-glow: rgba(192, 38, 211, 0.28);
  background: linear-gradient(135deg, #3b0f5c 0%, #1d1247 60%, #120b30 100%);
}

.new-paywall1,
.new-paywall2,
.new-paywall3,
.new-paywall4 {
  width: 100% !important;
  min-height: 132px !important;
  padding: 14px 18px !important;
  gap: 16px !important;

  ::v-deep .b-avatar {
    border: 3px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 0 0 2px #ea03b2, 0 0 18px rgba(234, 3, 178, 0.5);
  }

  p {
    font-size: 13.5px !important;
    line-height: 1.4;
  }
}

/* Butonlar: beyaz hap yerine gradyan */
.new-paywall1-button,
.new-paywall2-button,
.new-paywall3-button,
.new-paywall4-button,
.campaign-enable-premium-button {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
  padding: 9px 22px !important;
  border-radius: 9999px !important;
  color: #fff !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  background: linear-gradient(135deg, #ff1f8f, #7c3aed) !important;
  box-shadow: 0 6px 16px rgba(255, 31, 143, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.25);
  transition: filter .15s ease, transform .15s ease;

  &:hover { filter: brightness(1.1); transform: translateY(-1px); }
}

.new-paywall3-button {
  background: #fff !important;
  color: #a21caf !important;
}

.new-paywall4 .new-paywall4-button-top {
  width: auto !important;
  padding: 4px 14px !important;
  border-radius: 9999px !important;
  margin-bottom: 6px !important;
  background: rgba(255, 255, 255, 0.14) !important;
  border: 1px solid rgba(255, 255, 255, 0.25);
}

/* Geri sayım rozetleri */
.new-paywall1-counter,
.new-paywall3-counter,
.new-paywall4-counter,
.campaign-enable-premium-counter {
  top: 10px !important;
  bottom: auto !important;
  left: 10px !important;
  padding: 4px 12px !important;
  border-radius: 9999px !important;
  color: #fff !important;
  font-size: 11px !important;
  background: linear-gradient(135deg, #f59e0b, #ef4444) !important;
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.4);
}

.cp-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 48px 16px;
  border-radius: 20px;
  background: rgba(32, 22, 72, 0.72);
  border: 1px solid rgba(150, 110, 255, 0.28);
  text-align: center;

  h3 {
    color: #fff !important;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }
}

.cp-empty-icon {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: rgba(234, 3, 178, 0.18);
  border: 1px solid rgba(234, 3, 178, 0.4);
}

@media (max-width: 575px) {
  .cp-header .campaigns-title { font-size: 22px; }

  .new-paywall1-container,
  .new-paywall2-container,
  .new-paywall3-container,
  .new-paywall4-container { width: 100%; }
}
</style>
